// since jest doesn't have AudioContext
const SharedAudioContext =
  typeof AudioContext !== 'undefined' ? new AudioContext() : global.AudioContext

export default SharedAudioContext as AudioContext
